import { createSelector } from 'reselect';

const searchCommonSelector = (state) => state.search;

export const searchSelector = createSelector(searchCommonSelector, (item) => item || {});
